import { Component, Input, AfterViewInit, ElementRef, ViewChild, HostListener, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HelpPageComponent implements AfterViewInit {
  @Input() text = '';
  @Input() italic = true;
  @Input() clampLines = 2;
  @Input() showBackground = true;

  @ViewChild('textEl') textEl!: ElementRef;

  expanded = false;
  isTruncated = false;

  ngAfterViewInit() {
    // Run once after init
    setTimeout(() => this.checkTruncation());
  }

  @HostListener('window:resize')
  onResize() {
    this.checkTruncation();
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  private checkTruncation() {
    if (!this.textEl) return;
    const el = this.textEl.nativeElement;
    this.isTruncated = el.scrollHeight > el.clientHeight;
  }
}
